import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ListComponent } from './list.component';
import { FocusableDirective } from './../focusable/focusable.directive';
import { ButtonItemTemplateDirective } from './button-item-template.directive';
import { TemplateContextDirective } from './template-context.directive';
var EXPORTED_DIRECTIVES = [
    ListComponent,
    FocusableDirective,
    ButtonItemTemplateDirective,
    TemplateContextDirective
];
/**
 * @hidden
 */
var ListModule = (function () {
    function ListModule() {
    }
    return ListModule;
}());
export { ListModule };
ListModule.decorators = [
    { type: NgModule, args: [{
                declarations: [EXPORTED_DIRECTIVES],
                exports: [EXPORTED_DIRECTIVES],
                imports: [CommonModule]
            },] },
];
/** @nocollapse */
ListModule.ctorParameters = function () { return []; };



//////////////////
// WEBPACK FOOTER
// c:/Projects/YuDRIV/ServicesAPI/YuDriv-ServicesAPI/Enforcement/~/@progress/kendo-angular-buttons/dist/es/listbutton/list.module.js
// module id = ../../../../@progress/kendo-angular-buttons/dist/es/listbutton/list.module.js
// module chunks = 3